@if (product$ | async; as product) {
  <div>
    <p class="product-code">Part Nr.: {{ product.code }}</p>
  </div>
}
